<template>
    <div class="c-o-hero"  v-lazy-bg-image="hero.image.sizes.section_bg">
        <div class="c-o-hero__content">
            <h1 class="c-o-hero__title" v-html="hero.title"></h1>
            <div class="c-o-hero__form">
                <drilldown
                    class="c-a-drilldown--vertically-compact"
                    :dimLights="true"
                    :items="categories"
                    :placeholder="'Beskriv eller välj kategori'"
                    v-model="category"
                ></drilldown>
            </div>
            <div class="c-o-hero__body" v-html="hero.body"></div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { FETCH_FILTERS, GET_CATEGORIES, IS_LOADING, GET_ERROR } from '../../../store/store-models/filters-model';

    import Drilldown from '../atoms/form/AtomDrilldownCategories.vue'
    import Icon from '../atoms/AtomIcon.vue';

    export default {
        props: [
            'hero'
        ],
        components: {
            Drilldown,
            Icon
        },
        data() {
            return {
                chosenCategory: null
            }
        },
        computed: {
            ...mapGetters({
                categories: GET_CATEGORIES,
                isLoading: IS_LOADING,
                error: GET_ERROR
            }),
            category: {
                get() {
                    this.chosenCategory;
                },
                set (val) {
                    this.setCategory(val);
                }
            },
            backgroundStyle: function() {
                if(this.hero.image.sizes.section_bg){
                    return `url(${this.hero.image.sizes.section_bg})`;
                }
                return '';
            }
        },
        methods: {
            ...mapActions({
                fetchFilters: FETCH_FILTERS,
            }),
            setCategory(value) {
                this.chosenCategory = value;
                this.$router.push({path: `/skapa-forfragan/${value.Id}/`})
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/OrganismHeroHome.vue